import * as organizationConstants from '../constants/organizations';
import { LOCATION_CHANGE } from 'react-router-redux';
import routes from '../helpers/ApplicationRoutes';

export default function newBucketPage(state = {}, action) {
    switch (action.type) {
        case LOCATION_CHANGE:
            const { pathname } = action.payload;
            if (routes.organizationBuckets.isExactPath(pathname)) {
                return {
                    bucketName: '',
                    bucketDescription: '',
                    visibleInApplications: [],
                };
            } else {
                return {};
            }
        case organizationConstants.NEW_BUCKET_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case organizationConstants.CHANGE_NEW_BUCKET_NAME:
            return {
                ...state,
                bucketName: action.payload,
            };
        case organizationConstants.CHANGE_NEW_BUCKET_DESCRIPTION:
            return {
                ...state,
                bucketDescription: action.payload,
            };
        case organizationConstants.CHANGE_NEW_BUCKET_APPLICATION_PERMISSIONS_IDS:
            return {
                ...state,
                visibleInApplications: [...action.payload],
            };
        case organizationConstants.NEW_BUCKET_SUCCESS:
            return {
                ...state,
                error: undefined,
                loading: false,
            };
        case organizationConstants.NEW_BUCKET_FAILURE:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/newBucketPageReducer.js